<template>
  <div>
    <el-row :gutter="20">
      <el-timeline-item
        v-for="(group, index) in listVisitScoreGroup"
        :key="index"
        :color="'#0bbd87'"
        :size="'normal'"
      >
        <el-form ref="form">
          <span class="label-title">{{ group.appraisalGroupName }}</span>
          <el-divider direction="vertical"></el-divider>
          <span class="table-text">满分值：</span>
          <span class="table-text"
            ><b>{{ totalGroupTopScore(group.visitScoreGroupCode) }}</b></span
          >
          <el-divider direction="vertical"></el-divider>
          <span class="table-text">实际得分：</span>
          <span style="color: #007bff"
            ><b>{{ totalGroupScmScore(group.visitScoreGroupCode) }}</b></span
          >
          <el-row :gutter="50">
            <el-col
              v-for="(item, index) in group.listVisitScoreItem"
              :key="index"
              :sm="{ span: 24 }"
              :md="{ span: 24 }"
              :lg="{ span: 24 }"
            >
              <el-form-item
                :rules="[{ required: true }]"
                style=" margin-top: 12px;"
              >
                <div class="d-flex align-items-stretch">
                  <div style="width:75px;" class="table-text">
                    评分项目：
                  </div>
                  <div style="width:90%;" class="table-text">
                    {{ item.appraisalItemName }}
                  </div>
                </div>

                <div class="d-flex align-items-stretch">
                  <div style="width:75px" class="table-text">
                    评分说明：
                  </div>
                  <div style="width:90%" class="table-text">
                    {{ item.appraiseItemDesc }}
                  </div>
                </div>

                <div>
                  <el-row :gutter="50">
                    <el-col :span="24">
                      <div>
                        <span class="table-text">满分值：</span>
                        <span class="table-text"
                          ><b>{{ item.appraisalItemTopScore }}</b></span
                        >
                        <el-divider direction="vertical"></el-divider>
                        <span class="table-text">实际得分：</span>
                        <span style="color: #007bff"
                          ><b>{{ item.visitItemScore }}</b></span
                        >
                        <el-slider
                          :step="0.5"
                          show-stops
                          :max="item.appraisalItemTopScore"
                          v-model="item.visitItemScore"
                          :disabled="item.appraisalItemTopScore == 0"
                        >
                        </el-slider>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div>
                        <span slot="label">
                          <span>文字说明</span>
                        </span>
                        <el-input
                          v-model="item.visitItemValue"
                          maxlength="100"
                          show-word-limit
                          clearable
                          size="medium"
                        >
                        </el-input>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-timeline-item>
    </el-row>
  </div>
</template>
<script>
export default {
  props: {
    listVisitScoreGroup: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      data: {}
    }
  },
  mounted() {
    this.init()
  },
  computed: {},
  methods: {
    init() {},
    totalGroupTopScore: function(groupId) {
      // 获取各个分组的满分值
      let totGroupTopScore = 0
      let filterGroup = this.listVisitScoreGroup.filter((item) => {
        return item.visitScoreGroupCode == groupId
      })
      if (filterGroup.length > 0) {
        let itemList = filterGroup[0]
        itemList.listVisitScoreItem.forEach((element) => {
          totGroupTopScore += element.appraisalItemTopScore
        })
        itemList.appraisalGroupTopScore = totGroupTopScore
      }
      return totGroupTopScore
    },
    totalGroupScmScore: function(groupId) {
      // 获取各个分组的实际得分值
      let totGroupScmScore = 0
      let filterGroup = this.listVisitScoreGroup.filter((item) => {
        return item.visitScoreGroupCode == groupId
      })
      if (filterGroup.length > 0) {
        let itemList = filterGroup[0]
        itemList.listVisitScoreItem.forEach((element) => {
          totGroupScmScore += element.visitItemScore
        })
        itemList.visitGroupScore = totGroupScmScore
      }
      return totGroupScmScore
    },

    getData() {
      // const result = this.validate()
      // if (!result) {
      //   this.$message.error('请输入文字说明！')
      //   return
      // }
      return this.listVisitScoreGroup
    },

    validate() {
      let result = this.listVisitScoreGroup
        .map((g) => g.listVisitScoreItem.filter((t) => !t.visitItemValue))
        .filter((t) => t && t.length)
      return !result.length
    }
  }
}
</script>
<style lang="scss" scoped>
.table-text {
  color: #606266;
  font-size: 14px;
}
.label-title {
  color: #606266;
  font-size: 16px;
  font-weight: 500;
}

::v-deep .el-form-item__content {
  line-height: 25px;
}
</style>
